import "./styles.scss";

import moment from "moment";
import * as React from "react";
import { Badge, Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { GameI } from "../../../../../types";
import { useEffect, useState } from "react";
import { useGetGameImage } from "../../../../../hooks/getGameImage";
import { StarFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export const GamePreview: React.FC<{ game: GameI }> = (props) => {
    const { game } = props;

    const { t } = useTranslation();

    const [cardImage, setCardImage] = useState<string | null>();

    const { sendRequest: fetchGameImage } = useGetGameImage();

    useEffect(() => {
        if (game.picture.poster) {
            fetchGameImage({ image: game.picture.poster, platform: game.platform }, (image) => {
                setCardImage(image);
            });
        } else if (game.picture.menu) {
            fetchGameImage({ image: game.picture.menu, platform: game.platform }, (image) => {
                setCardImage(image);
            });
        } else if (game.picture.intro) {
            fetchGameImage({ image: game.picture.intro, platform: game.platform }, (image) => {
                setCardImage(image);
            });
        } else if (game.picture.inGame) {
            fetchGameImage(
                {
                    image: game.picture.inGame.replace("[N]", "1") + "." + game.jpgImages ? "jpg" : "png",
                    platform: game.platform,
                },
                (image) => {
                    setCardImage(image);
                }
            );
        }
        // eslint-disable-next-line
    }, [fetchGameImage]);

    return (
        <Card className={"mb-3"}>
            {cardImage ? (
                <>
                    <NavLink to={`/show-game/${game.url}`}>
                        <Card.Img variant={"top"} src={cardImage} />
                    </NavLink>

                    {game.rating.total ? (
                        <Badge bg={"primary"} className={"rating"} pill>
                            <StarFill /> {game.rating.total} / 10
                        </Badge>
                    ) : null}
                </>
            ) : null}

            <Card.Body>
                <Card.Title className={"text-center"}>
                    <NavLink to={`/show-game/${game.url}`}>{game.title}</NavLink>
                </Card.Title>

                <Card.Text className={"text-center platform"}>
                    <Badge bg={"light"} pill className={"text-dark"}>
                        {game.platform}
                    </Badge>
                </Card.Text>

                <Card.Text className={"text-center publish"}>
                    <span className={"publisher"}>{game.publisher}</span>
                    {game.date.published ? (
                        <span className={"date-published"}>{moment(game.date.published).format("YYYY")}</span>
                    ) : null}
                </Card.Text>

                {game.genre ? (
                    <Card.Text className={"text-center genres"}>
                        {game.genre.map((genre: string, index: number) => {
                            return (
                                <span className={"genre"} key={`${game.url}-${genre}`}>
                                    <NavLink to={`/games/genre/${genre}`}>{t(genre)}</NavLink>
                                </span>
                            );
                        })}
                    </Card.Text>
                ) : null}
            </Card.Body>
        </Card>
    );
};
